import $ from 'jquery';

$('.about-values__title').click(function () {
    if ($(window).width() < 1024) {
        $(this).siblings('.about-values-card').toggleClass('about-values-card--visible');
    }
});
